// extracted by mini-css-extract-plugin
export default {"draggerContainer":"styles_draggerContainer__jApUa"};